/**
 * Espejo de backend/app/Support/RequerimientosLogisticos.php.
 *
 * Todos los mínimos configurados en mayor a cero son exigibles y el porcentaje que se
 * informa es el del requisito más incumplido. Si cambia el criterio hay que cambiarlo
 * en los dos lados: el backend es el que decide, esto es sólo lo que ve el usuario
 * mientras edita.
 */
const REQUERIMIENTOS = [
  { minimo: 'bultos_minimo', total: 'bultos' },
  { minimo: 'valorizado_minimo', total: 'valorizado' },
  { minimo: 'pallet_minimo', total: 'pallets' },
]

const formatearPorcentaje = (porcentaje) =>
  porcentaje > 0 && porcentaje < 1 ? 1 : Math.round(porcentaje)

/**
 * @param {object} minimos fila de prov_minimo_zona de la zona (minimo_log).
 * @param {object} totales totales del pedido: bultos, valorizado y pallets.
 */
export function calcularPorcentajeRequerimientos(minimos, totales) {
  let porcentaje = 100

  REQUERIMIENTOS.forEach(({ minimo, total }) => {
    const valorMinimo = parseFloat(minimos?.[minimo])
    if (!(valorMinimo > 0)) return

    // Un total que todavía no se pudo calcular no se puede medir acá: lo resuelve el
    // backend al generar la orden.
    const actual = parseFloat(totales?.[total])
    if (!isFinite(actual) || actual >= valorMinimo) return

    porcentaje = Math.min(porcentaje, (actual / valorMinimo) * 100)
  })

  return formatearPorcentaje(porcentaje)
}

/**
 * Los proveedores de marca líder son los únicos para los que el backend rechaza la
 * generación de la orden si no se alcanzan los mínimos, así que son los únicos en los
 * que la pantalla bloquea en vez de advertir.
 */
export function esMarcaLider(tipoProveedor) {
  return ['1', '2'].includes(String(tipoProveedor))
}

/**
 * Si el proveedor tiene al menos un mínimo cargado en mayor a cero para la zona.
 *
 * @param {object} minimos fila de prov_minimo_zona de la zona (minimo_log).
 */
export function tieneRequerimientos(minimos) {
  return REQUERIMIENTOS.some(({ minimo }) => parseFloat(minimos?.[minimo]) > 0)
}

/**
 * En marca líder los mínimos son parte de la negociación con el proveedor: que no estén
 * cargados para la zona es un dato faltante y no una excepción al control, así que el
 * backend también rechaza la orden. La pantalla lo avisa antes de intentarlo.
 */
export function bloqueaPorFaltaDeRequerimientos(tipoProveedor, minimos) {
  return esMarcaLider(tipoProveedor) && !tieneRequerimientos(minimos)
}

export const MENSAJE_SIN_REQUERIMIENTOS =
  'El proveedor no tiene requerimientos logísticos mínimos configurados para la zona: ' +
  'no se puede generar la orden de compra.'
